import { useState } from 'react'
import { useClickOutside } from 'hooks/useClickOutside'
import clsx from 'clsx'
import { InlineError, Input } from 'avo-ui'
import Search from 'components/commons/search'
import { capitalize } from 'utils/utils'
import icCloseRoundRed from 'assets/images/ic-close-round-red.svg'

export const MultipleSelectGift = ({ name, options, value, onSearch, onChange, errors }) => {
    const [showOptions, setShowOptions] = useState(false)
    const [keyword, setKeyword] = useState('')

    const isNotExistSelectedItem = (item) => {
        return !value?.find((i) => i?.label === item?.label)
    }

    const onSelect = (selectedItem) => {
        setShowOptions(false)
        if (onSearch) setKeyword('')
        if (isNotExistSelectedItem(selectedItem))
            onChange({ name, value: [...value, { ...selectedItem, quantity: 0 }] })
    }

    const onChangeQuantity = (index, quantity) => {
        const copyValue = [...value]
        copyValue[index] = { ...copyValue[index], quantity: Number(quantity) }
        onChange({ name, value: copyValue })
    }

    const onSearchHandler = (keyword) => {
        if (onSearch) onSearch(keyword)
        setKeyword(keyword)
        setShowOptions(true)
    }

    const onDelete = (item) => {
        const filterSelected = value?.filter((i) => i?.label !== item?.label)
        onChange({ name, value: filterSelected })
    }

    useClickOutside({
        callback: () => setShowOptions(false),
        elementID: `multiple-select-${name}`,
    })

    return (
        <div id={`multiple-select-${name}`} className={'relative'}>
            <Search value={keyword} onSearch={onSearchHandler} />
            <div
                className={clsx(
                    'w-[90%] flex flex-col mx-8 space-y-2 -mt-1 border rounded-lg z-30 bg-white absolute max-h-36 overflow-auto',
                    showOptions ? 'block' : 'hidden',
                )}
            >
                {options?.length ? (
                    options?.map((item, index) => (
                        <div
                            key={index}
                            className={'capitalize text-[#2B2B2B] p-2 hover:bg-[#F2F7FF] cursor-pointer'}
                            onClick={() => onSelect(item)}
                        >
                            {item?.label}
                        </div>
                    ))
                ) : (
                    <div className={'p-2'}>Not Found</div>
                )}
            </div>
            <div
                className={clsx(
                    'flex items-center justify-between -mt-0.5 py-2 bg-blue-5',
                    value?.length ? 'block' : 'hidden',
                )}
            >
                <div className={'pl-12 basis-2/4'}>Selected Gift</div>
                <div className={'pl-4 basis-1/4'}>Qty</div>
                <div />
            </div>
            <div
                className={clsx(
                    'flex flex-col space-y-4 -mt-1 p-4 border-x border-b rounded-b-lg max-h-56 overflow-auto',
                    value?.length ? 'block' : 'hidden',
                )}
            >
                {value?.map((item, index) => (
                    <div key={index} className={'flex justify-between'}>
                        <div className={clsx('flex items-center space-x-2 basis-2/4', errors?.[index] && '-mt-11')}>
                            <img
                                src={icCloseRoundRed}
                                alt={'ic-close-rounded-red'}
                                className={'w-6 h-6 cursor-pointer'}
                                onClick={() => onDelete(item)}
                            />
                            {item?.image_url && <img src={item?.image_url} alt={'image'} className={'w-8 h-8'} />}
                            <p>{capitalize(item?.label)}</p>
                        </div>
                        <div className={'flex flex-col space-y-3 basis-1/4'}>
                            <Input
                                type={'number'}
                                className={'w-16'}
                                name={'max_amount'}
                                placeholder={'Qty'}
                                value={item?.quantity}
                                onChange={(item) => onChangeQuantity(index, item?.value)}
                            />
                            <InlineError className={'mt-2'} message={errors?.[index]} />
                        </div>
                        <div />
                    </div>
                ))}
            </div>
        </div>
    )
}
